import { Link } from 'src/viewLayer/components/DesignSystem'
import styled from 'styled-components'

export const InterpolatedLink = styled(Link)`
  position: relative;
  top: -2.5px;
`
